import { Component, Input, OnInit } from '@angular/core'
import { UserPreferences } from '@tv3/store/user-preferences/user-preferences.model'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { selectUserPreferences } from '@tv3/store/user-preferences/user-preferences.selectors'
import { UpdateUserPreferences } from '@tv3/store/user-preferences/user-preferences.actions'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { selectSome } from '@tokeet/tv3-platform'
import * as lodash from 'lodash'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { inquiriesRouteMapping } from '@tv3/constants/inquiries-route-mapping'

@Component({
  selector: 'app-default-inbox-indicator',
  templateUrl: './default-inbox-indicator.component.html',
  styleUrls: ['./default-inbox-indicator.component.scss'],
})
export class DefaultInboxIndicatorComponent extends Destroyable implements OnInit {
  @Input() inboxName

  userPreference: UserPreferences
  isDefaultView = false

  constructor(private store: Store<fromRoot.State>, private amplitudeService: AmplitudeService) {
    super()
  }

  ngOnInit() {
    this.store.pipe(selectSome(selectUserPreferences), untilDestroy(this)).subscribe((userPref: UserPreferences) => {
      this.userPreference = userPref
      this.isDefaultView = this.userPreference.defaultInbox === this.inboxName
    })
  }

  setAsDefaultView() {
    if (this.isDefaultView) {
      return
    }
    const payload = {
      id: this.userPreference.id,
      form: { default_inbox: this.inboxName },
    }
    const url =
      lodash.find(lodash.values(inquiriesRouteMapping), (v) => v.name === this.inboxName).url || this.inboxName
    this.amplitudeService.logEvent(`default-inquiries-view-${url}`)
    this.store.dispatch(UpdateUserPreferences(payload))
  }
}
